import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import SearchIcon from '@mui/icons-material/Search';
import { Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { Accordion } from '../../../../../components/general/accordion';
import { TitleV1 } from '../../../../../components/titleV1';
import LoadingButtonGeneral from '../../../../../components/general/buttons/loadingButtonGeneral';

import { QUOTATION } from '../../../../../../routes/paths';
import { QuotationForm } from '../../../quotation/form';

export const AccountRegisterQuotationForm = () => {
    const navigate = useNavigate();

    return (
        <Accordion
            title="REGISTRO COTIZACIÓN"
            icon={<ShoppingCartIcon sx={{ color: 'primary.main' }} />}
            defaultExpanded={false}
            mt={0}
            padding={0}
        >
            <TitleV1 title="SOLICITUD DE COTIZACIÓN">
                <LoadingButtonGeneral
                    title="Buscar"
                    variant="outlined"
                    startIcon={<SearchIcon />}
                    onClick={() => navigate(QUOTATION)}
                />
            </TitleV1>
            <Grid px="16px">
                <QuotationForm />
            </Grid>
        </Accordion>
    );
};
